import { customerState } from '../../model/details/customer';

// Types
import { LeadDetailRawType } from '../../types/Lead';

export default function transformCustomerState(data: LeadDetailRawType) {
    const map = new Map();
    let _transform = {};

    map.set('customer.knownCustomer', 'knownCustomer');
    map.set('customer.title', 'title');
    map.set('customer.firstName', 'firstName');
    map.set('customer.lastName', 'lastName');
    map.set('customer.birthdate', 'birthdate');
    map.set('customer.email', 'email');
    map.set('customer.mobilePhoneNumber', 'mobilePhoneNumber');
    map.set('customer.employedSince', 'employedSince');
    map.set('customer.address.city', 'city');
    map.set('customer.address.country', 'country');
    map.set('customer.address.houseNumber', 'houseNumber');
    map.set('customer.address.postalCode', 'postalCode');
    map.set('customer.address.streetName', 'streetName');
    map.set('customer.address.addressAddition', 'addressAddition');

    map.forEach((uiKey, apiKey) => {
        const [type, subKey, subKeyType] = apiKey.split('.');
        const [pType, pSubKey] = uiKey.split('.');
        let _val;

        // 3. rank : 3 keys like energyInfo.wltpInfo.co2EmissionCombined
        if (subKeyType && subKey && data[type][subKey]) {
            const _v = data[type][subKey][subKeyType];

            _val = _v === null ? customerState[pType][pSubKey] : data[type][subKey][subKeyType];
        }
        // 2. rank : 2 keys like energyInfo.nefzIsEmpty
        else if (subKey && data[type]) {
            _val = data[type][subKey];
        }
        // 1. rank : standard
        else {
            _val = data[apiKey] === null ? customerState[uiKey] : data[apiKey];
        }

        _transform = {
            ..._transform,
            [uiKey]: _val === null ? customerState[uiKey] : _val,
        };
    });

    return _transform;
}
